import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { colorGrayLight4 } from 'styles/layout/colors';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import customerDashboardLinks from '../../customerDashboardLinks';

export const allLinks = item => item;
export const removeQuoteLink = ({ path }) => path !== '/quote/';

const CustomerDashboardLinksUI = ({ showQuoteLink = false }) => (
  <div className="m-[0-1rem] lg:grid lg:gap-6 lg:grid-cols-[1fr_1fr] lg:m-0">
    {customerDashboardLinks
      .filter(showQuoteLink ? allLinks : removeQuoteLink)
      .map(({ label, path, description, icon: Icon }) => (
        <Link
          to={path}
          className={classNames(
            'group/CustomerDashboardLinksUI__item',
            'items-center border border-solid border-gray-light6 flex pt-6 pr-6 pb-6 pl-4 relative no-underline max-[1023px]:border-l-0 max-[1023px]:border-r-0 max-[1023px]:border-t-0 max-[1023px]:pr-10 lg:rounded lg:px-8 lg:py-12',
            'first:max-[1023px]:border-t',
            'hover:!no-underline hover:bg-gray-light9 hover:cursor-pointer'
          )}
          key={path}
        >
          <Icon
            color={colorGrayLight4}
            className="mr-8 max-[1023px]:h-[38px] max-[1023px]:mr-4 max-[1023px]:w-[38px]"
          />

          <div className="flex-1">
            <div className="text-lg font-bold !text-gray flex justify-between lg:text-xl lg:font-bold lg:items-center lg:inline-flex lg:justify-start">
              <span className="lg:mr-3.5">{label}</span>

              <span className="max-[1023px]:items-center max-[1023px]:bottom-0 max-[1023px]:flex max-[1023px]:justify-center max-[1023px]:px-6 max-[1023px]:py-0 max-[1023px]:absolute max-[1023px]:right-0 max-[1023px]:top-0 lg:hidden group-hover/CustomerDashboardLinksUI__item:lg:block">
                <IconArrowRightSimple width={7} height={12} />
              </span>
            </div>

            <div className="text-sm !text-gray-light2 max-[1023px]:text-xs">
              {description}
            </div>
          </div>
        </Link>
      ))}
  </div>
);

CustomerDashboardLinksUI.propTypes = {
  showQuoteLink: PropTypes.bool,
};

export default CustomerDashboardLinksUI;
